<template>
  <div class="dod20" ref="dod20">
    <div class="dod20_color1" ref="color1" />
    <div class="dod20_color2" ref="color2" />
    <div class="dod20_text" ref="text">
      Dominant Color<br>
      Dominant Color<br>
      Dominant Color<br>
      Dominant Color<br>
      Dominant Color<br>
    </div>
    <div class="dod20_thumbnail" ref="thumbnail">
      <img class="dod20_thumbnail_image" v-if="image" v-bind:src="image.src" />
    </div>
    <div class="dod20_arrow is-prev" v-on:click="changeImage('prev')">← Prev</div>
    <div class="dod20_arrow is-next" v-on:click="changeImage('next')">Next →</div>
    <a class="dod20_copyright" v-if="image" v-bind:href="image.url" target="_blank">{{ image.alt || image.url }}</a>
  </div>
</template>

<script>
import { DominantColor } from '@/modules/day20-dominantColor'

export default {
  name: 'Day20',
  data: () => ({
    image: '',
    images: [
      {
        url: 'https://unsplash.com/photos/-6zBD9R48LA',
        alt: 'Photo by Lefteris kallergis on Unsplash',
        src: require('@/assets/images/dod/20/img_10.jpg')
      },
      {
        url: 'https://unsplash.com/photos/-6zBD9R48LA',
        alt: 'Photo by Lefteris kallergis on Unsplash',
        src: require('@/assets/images/dod/20/dod19_image_03.jpg')
      },
      {
        url: 'https://unsplash.com/photos/-6zBD9R48LA',
        alt: 'Photo by Lefteris kallergis on Unsplash',
        src: require('@/assets/images/dod/20/dod_23_01.jpg')
      },
      {
        url: 'https://unsplash.com/photos/-6zBD9R48LA',
        alt: 'Photo by Lefteris kallergis on Unsplash',
        src: require('@/assets/images/dod/20/dod_23_02.jpg')
      },
      {
        url: 'https://unsplash.com/photos/-6zBD9R48LA',
        alt: 'Photo by Lefteris kallergis on Unsplash',
        src: require('@/assets/images/dod/20/dod_23_03.jpg')
      },
      {
        url: 'https://unsplash.com/photos/-6zBD9R48LA',
        alt: 'Photo by Lefteris kallergis on Unsplash',
        src: require('@/assets/images/dod/20/dod_23_04.jpg')
      },
      {
        url: 'https://unsplash.com/photos/-6zBD9R48LA',
        alt: 'Photo by Lefteris kallergis on Unsplash',
        src: require('@/assets/images/dod/20/image_02.jpg')
      },
      {
        url: 'https://unsplash.com/photos/-6zBD9R48LA',
        alt: 'Photo by Lefteris kallergis on Unsplash',
        src: require('@/assets/images/dod/20/image_03.jpg')
      },
      {
        url: 'https://unsplash.com/photos/-6zBD9R48LA',
        alt: 'Photo by Lefteris kallergis on Unsplash',
        src: require('@/assets/images/dod/20/image_04.jpg')
      },
      {
        url: 'https://unsplash.com/photos/-6zBD9R48LA',
        alt: 'Photo by Lefteris kallergis on Unsplash',
        src: require('@/assets/images/dod/20/image_05.jpg')
      },
      {
        url: 'https://unsplash.com/photos/-6zBD9R48LA',
        alt: 'Photo by Lefteris kallergis on Unsplash',
        src: require('@/assets/images/dod/20/image_06.jpg')
      },
      {
        url: 'https://unsplash.com/photos/-6zBD9R48LA',
        alt: 'Photo by Lefteris kallergis on Unsplash',
        src: require('@/assets/images/dod/20/image_07.jpg')
      },
      {
        url: 'https://unsplash.com/photos/-6zBD9R48LA',
        alt: 'Photo by Lefteris kallergis on Unsplash',
        src: require('@/assets/images/dod/20/image_08.jpg')
      },
      {
        url: 'https://unsplash.com/photos/-6zBD9R48LA',
        alt: 'Photo by Lefteris kallergis on Unsplash',
        src: require('@/assets/images/dod/20/image_09.jpg')
      },
      {
        url: 'https://unsplash.com/photos/AxI9niqj_60',
        alt: 'Photo by Lefteris kallergis on Unsplash',
        src: require('@/assets/images/dod/20/img_02.jpg')
      },
      {
        url: 'https://unsplash.com/photos/6CmfWqCNeIo',
        alt: 'Photo by Ikhsan Sugiarto on Unsplash',
        src: require('@/assets/images/dod/20/img_03.jpg')
      },
      {
        url: 'https://unsplash.com/photos/l8DUam8vtbc',
        alt: 'Photo by Paweł Czerwiński on Unsplash',
        src: require('@/assets/images/dod/20/img_04.jpg')
      },
      {
        url: 'https://unsplash.com/photos/RnCPiXixooY',
        alt: 'Photo by Efe Kurnaz on Unsplash',
        src: require('@/assets/images/dod/20/img_05.jpg')
      },
      {
        url: 'https://unsplash.com/photos/9HuDexeBUKE',
        alt: 'Photo by Mark Fletcher-Brown on Unsplash',
        src: require('@/assets/images/dod/20/img_06.jpg')
      },
      {
        url: 'https://unsplash.com/photos/4nabmlliGdU',
        alt: 'Photo by Paul Hanaoka on Unsplash',
        src: require('@/assets/images/dod/20/img_07.jpg')
      },
      {
        url: 'https://unsplash.com/photos/KKm2c2lxH_s',
        alt: 'Photo by alexey turenkov on Unsplash',
        src: require('@/assets/images/dod/20/img_08.jpg')
      },
      {
        url: 'https://unsplash.com/photos/LEC0hr8KJjM',
        alt: 'Photo by Azamat Zhanisov on Unsplash',
        src: require('@/assets/images/dod/20/img_09.jpg')
      }
    ],
    pixi: false,
    index: 0
  }),

  methods: {
    async changeImage(direction = 'next') {
      this.loading = true

      this.index = (direction === 'next') ? this.index + 1 : this.index - 1
      if (this.index >= this.images.length) {
        this.index = 0
      }
      if (this.index < 0) {
        this.index = this.images.length - 1
      }

      this.image = this.images[this.index]

      const colors = await this.pixi.init(this.image.src)

      document.getElementById('dod20').style.color = colors.hslText
      this.$refs.dod20.style.backgroundColor = colors.hsl
      this.$refs.text.style.color = colors.secondaryHsl

      this.loading = false
    }
  },

  beforeDestroy() {
  },

  async mounted() {
    this.image = this.images[this.index]

    this.pixi = new DominantColor(this.$refs.thumbnail)
    const dominantColor = await this.pixi.init(this.image.src)

    // Text Color
    document.getElementById('dod20').style.color = dominantColor.hslText
    this.$refs.text.style.color = dominantColor.secondaryHsl
    this.$refs.dod20.style.backgroundColor = dominantColor.hsl
  }
}
</script>

<style lang="scss">
.dod20 {
  @include FR_FULLSIZE;
  @include FR_FLEX_LAYOUT(center, center);
  overflow: hidden;
  text-align: center;
  // transition:
  //   background-color 300ms ease-in-out,
  //   color 300ms ease-out;
}

.dod20_thumbnail {
  @include FR_FLEX_LAYOUT(center, center);
  position: relative;
  z-index: 5;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  img {
    max-width: 30%;
    height: auto;
    margin-right: 5%;
    // transition: all 300ms ease-out;
  }
  > canvas {
    margin-left: 5%;
    width: 10vw !important;
    height: 10vw !important;
    // transition: all 300ms ease-out;
  }
}

.dod20_copyright {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  right: 1rem;
  @include FONTSIZE(S);
  display: block;
  &:hover {
    text-decoration: underline;
  }
}

.dod20_text {
  @include FR_CENTER(xy);
  @include FR_FLEX_LAYOUT(center, center);
  position: absolute;
  width: 200%;
  height: 150%;
  text-align: center;
  font-size: 8vw;
  letter-spacing: 0.025em;
  font-weight: 900;
  text-transform: uppercase;
  pointer-events: none;
  transition: color 300ms ease-out;
}

.dod20_arrow {
  position: absolute;
  top: 50%;
  height: 2rem;
  line-height: 2rem;
  margin-top: -1rem;
  font-size: 1.2em;
  text-transform: uppercase;
  cursor: pointer;
  z-index: 10;
  &.is-prev {
    left: 2rem;
  }
  &.is-next {
    right: 2rem;
  }
}
</style>
